import { useReducedMotion } from "framer-motion";
import { img } from "@/lib/media";

export const GalleryVideo = ({ item, alt, className, posterWidth = 960 }) => {
  const reduce = useReducedMotion();
  const poster = img(item.file, posterWidth);
  if (reduce) return <img src={poster} alt={alt} className={className} />;
  return (
    <video className={className} poster={poster} autoPlay muted loop playsInline
      preload="metadata" aria-label={alt} width={item.width} height={item.height}
      style={{ aspectRatio: `${item.width} / ${item.height}` }}>
      <source src={item.video} type="video/mp4" />
      <source src={item.video.replace(/\.mp4$/, ".webm")} type="video/webm" />
    </video>
  );
};
